module.exports = __webpack_public_path__ + "static/media/btn-top-red.0b0f4ecd.svg";